<template>
  <div>
    <section class="page-banner"><img :src="assets.kitchenOverview" :alt="$t('article.title')"><div><p class="eyebrow">KITCHEN DESIGN NOTES</p><h1>{{ $t('article.title') }}</h1><p>{{ $t('article.subtitle') }}</p></div></section>
    <div class="breadcrumb"><router-link to="/">{{ $t('common.home') }}</router-link><span>/</span>{{ $t('article.title') }}</div>
    <article class="section narrow prose">
      <p class="eyebrow">DESIGN KNOWLEDGE</p><h2>{{ $t('article.introTitle') }}</h2><p>{{ $t('article.intro') }}</p>
      <template v-for="number in [1,2,3,4]"><h3 :key="`h-${number}`">{{ $t(`article.h${number}`) }}</h3><p :key="`p-${number}`">{{ $t(`article.p${number}`) }}</p></template>
      <p class="source-note">{{ $t('article.note') }}</p><a class="text-link" :href="`${documents.companyProfile}#page=12`" target="_blank" rel="noopener noreferrer">{{ $t('article.source') }} <span>↗</span></a>
    </article>
    <ContactCta />
  </div>
</template>
<script>
import ContactCta from '../components/ContactCta.vue'
import { assets, documents } from '../data/site'
export default { name: 'ArticleView', components: { ContactCta }, data() { return { assets, documents } } }
</script>
